module.exports = __webpack_public_path__ + "media/images/fondatrice-61a6795f4f97dc76d8f391ae25445b4d.jpg";